import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';

// const options = {
//     confirmButtonColor: '#C4170C',
//     cancelButtonColor: '#707070',
// };

Vue.use(VueSweetalert2);